<template>

  <v-flex xs12>
    <!--p class="text-lg-center display-1">About</p-->

    <p class="text-xs-center title" ><span class="cyan--text darken-3">BankPDF CRM</span></p>

    <p class="text-xs-left text-item">Это приложение представляет собой расширение функционала телеграм бота по проверке PDF чеков BankPDF bot. Реализован функционал просмотра истории проверок, объединение аккаунтов телеграм в команды, с разделением на руководителя и сотрудников (сотрудник может работать только со своими проверками, руководитель имеет возможность контролировать работу сотрудников), автоматический подсчет оборота.
    </p>
    <p class="text-xs-left text-item">1. PDF проверки: в этот список автоматически попадают все проверки чеков в боте (основного аккаунта и аккаунтов присоединенных сотрудников), в этом режиме доступны фильтры в верхней части экрана, а также поле контекстного поиска над списком ордеров. Имеется возможность открыть проверенный чек через ссылку "Открыть".
    </p>
    <p class="text-xs-left text-item">2. Почта: список принятых писем на почту в боте, с возможностью скачать исходный код принятого письма.
    </p>
    <p class="text-xs-left text-item">3. Ордера: список ордеров Bybit с возможностью подсчитать итоги и средний курс.
    </p>
    <p class="text-xs-left text-item">4. Статистика: при выборе этого пункта меню отображается сводная информация о проведенных проверках в графическом виде, так же доступны фильтры в верхней строке.
    <p class="text-xs-left text-item">5. Сотрудники: в меню можно просмотреть/добавить сотрудников в команде, для добавления сотрудника в команду нажмите кнопку + и попросите сотрудника отправить отображаемый код боту @bankpdfbot.
    </p>
   <p class="text-xs-left text-item">6. Поиск по базе контрагентов ByBit.
   <p class="text-xs-left text-item">7. BlackList: список отчетов о скам аккаунтах ByBit/HTX, полученный из открытых источников.
    </p>

    
  </v-flex>

</template>
<script>
export default {
  mounted() {
   this.$Progress.finish();
  }
}
</script>
<style scoped>
    .text-item {
      font-size: 18px;
      text-align: right;
    }
    .select-box {
      margin-left: 15px;
      margin-top: 15px;
      max-width: 110px;
    }
</style>




// WEBPACK FOOTER //
// About.vue?31e653ed